import { z } from 'zod';

export enum ChainAvailabilityStatus {
    AVAILABLE = 'AVAILABLE',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
}

export const chainAvailabilityItemSchema = z.object({
    step_order: z.number().int().nonnegative(),
    appointment_type_id: z.string(),
    appointment_type_key: z.string(),
    calendar_id: z.string(), // BE-resolved calendar for this step
    start_date: z.iso.datetime(), // ISO datetime UTC
    end_date: z.iso.datetime(), // ISO datetime UTC
    status: z.enum(ChainAvailabilityStatus),
});

export const chainAvailabilityResponseSchema = z.object({
    data: z.array(chainAvailabilityItemSchema),
});

export type ChainAvailabilityItem = z.infer<typeof chainAvailabilityItemSchema>;
